interface AccordionIconProps {
    opened?: boolean;
    color?: string;
    className?: string;
}

function AccordionIcon({ opened = false, color = 'currentColor', className }: AccordionIconProps) {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            {opened ? (
                <g>
                    <path
                        d="M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z"
                        stroke={color}
                    />
                    <rect
                        x="19"
                        y="11"
                        width="2"
                        height="14"
                        transform="rotate(90 19 11)"
                        fill={color}
                    />
                </g>
            ) : (
                <path
                    d="M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C9.66386e-08 5.37258 5.37258 9.66416e-08 12 0ZM11 5V11H5V13H11V19H13V13H19V11H13V5H11Z"
                    fill={color}
                />
            )}
        </svg>
    );
}

export default AccordionIcon;
